const getAllUsers = (state)=>state.users;
const getComponentKey = (state)=>state.count;

export {
    getAllUsers,
    getComponentKey
}